type ConcernGroupVariant = "primary" | "other";
type TopicConcernVariant = "positive" | ConcernGroupVariant;

export const getFocusUrgencyBadgeStyles = (urgencyLevel?: string) => {
  const normalizedUrgencyLevel = urgencyLevel?.trim().toLowerCase();

  switch (normalizedUrgencyLevel) {
    case "recommended":
      return {
        backgroundColor: "#FEF3C7",
        color: "#B45309",
        border: "1px solid #FDE68A",
      };
    case "critical - must attend":
      return {
        backgroundColor: "#FEE2E2",
        color: "#B91C1C",
        border: "1px solid #FECACA",
      };
    case "not needed":
      return {
        backgroundColor: "#F5F3FF",
        color: "#6D28D9",
        border: "1px solid #DDD6FE",
      };
    case "optional":
    default:
      return {
        backgroundColor: "#F3E8FF",
        color: "#7C3AED",
        border: "1px solid #E9D5FF",
      };
  }
};

export const fingertipMetricViewStyles = {
  summaryCard: {
    border: "1px solid #EAEAEA",
    borderRadius: "8px",
    padding: "14px",
    backgroundColor: "#fff",
    position: "relative",
    width: "100%",
  },
  card: {
    border: "1px solid #EAEAEA",
    borderRadius: "8px",
    padding: "16px",
    backgroundColor: "#fff",
    position: "relative",
    width: "100%",
  },
  title: {
    fontWeight: 600,
    fontSize: "16px",
    marginBottom: "4px",
    color: "#6036D6",
  },
  sectionHeading: {
    fontWeight: 600,
    fontSize: "16px",
    marginBottom: "16px",
    color: "#6036D6",
  },
  headingText: {
    fontSize: "13px",
    lineHeight: "20px",
  },
  bulletText: {
    fontSize: "13px",
    lineHeight: "20px",
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    "&::before": {
      content: '"•"',
      lineHeight: "20px",
    },
  },
  listItem: {
    fontSize: "13px",
    lineHeight: "24px",
    color: "#2E2E2E",
    display: "list-item",
    marginLeft: "18px",
  },
  highlight: {
    backgroundColor: "#EFEBFB",
    color: "#6036D6",
    padding: "0px 4px",
    borderRadius: "4px",
    fontWeight: 600,
    display: "inline-block",
    marginLeft: "2px",
  },
  trajectoryHighlight: {
    backgroundColor: "#E9F8EF",
    color: "#129455",
    padding: "3px 12px",
    borderRadius: "99px",
    fontWeight: 600,
    display: "inline-block",
    fontSize: "13px",
  },
  trendsCard: {
    height: "100%",
  },
  trendsGridContainer: {
    alignItems: "stretch",
  },
  trendsGridItem: {
    display: "flex",
    flexDirection: "column",
  },
  trajectoryCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  trajectoryWrap: {
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "22px",
    height: "100%",
    textAlign: "center",
  },
  trajectoryTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#31343F",
    lineHeight: 1.3,
  },
  trajectoryBadge: {
    padding: "6px 14px",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: 600,
  },
  summarySectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },
  summarySectionIcon: {
    width: 28,
    height: 28,
    borderRadius: "9px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  executiveSummaryIcon: {
    backgroundColor: "#DBEAFE",
  },
  interestEvolutionIcon: {
    backgroundColor: "#DBEAFE",
  },
  summarySectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1F1F1F",
    lineHeight: 1.3,
  },
  summaryContentPanel: {
    borderRadius: "12px",
    padding: "4px 12px",
  },
  executiveSummaryPanel: {
    background: "linear-gradient(90deg, #EFF6FF 0%, #F5F0FF 100%)",
    borderLeft: "4px solid #3B82F6",
  },
  interestEvolutionPanel: {
    background: "linear-gradient(90deg,  #EFF6FF 0%, #F5F0FF 100%)",
    borderLeft: "4px solid #3B82F6",
  },
  summaryContentSpacer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "10px",
  },
  summaryContentText: {
    fontSize: "14px",
    lineHeight: 1.75,
    color: "#4B5563",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "18px",
  },
  sectionIcon: {
    width: 28,
    height: 28,
    borderRadius: "9px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  whereToFocusIcon: {
    backgroundColor: "#F3E8FF",
  },
  relationshipIcon: {
    backgroundColor: "#FFEDD5",
  },
  factsIcon: {
    backgroundColor: "#E0E7FF",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1F1F1F",
    lineHeight: 1.3,
  },
  factsSectionTitle: {
    fontSize: "15px",
    fontWeight: 500,
  },
  factsHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },
  focusSectionsWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  focusSubsectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  focusSubsectionTitle: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#111827",
  },
  focusUrgencyBadge: {
    px: 1.5,
    py: "3px",
    borderRadius: "999px",
    fontSize: "11px",
    fontWeight: 500,
  },
  focusBodyText: {
    fontSize: "13px",
    color: "#4B5563",
    lineHeight: 1.7,
  },
  focusIntroText: {
    fontSize: "13px",
    color: "#4B5563",
    mb: 1.5,
    lineHeight: 1.7,
  },
  focusList: {
    pl: 3,
    m: 0,
    listStyleType: "decimal",
  },
  focusListItem: {
    fontSize: "13px",
    color: "#4B5563",
    mb: 1,
    lineHeight: 1.7,
  },
  relationshipTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  relationshipTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#111827",
  },
  relationshipContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  relationshipIconGraphic: {
    fontSize: 16,
    color: "#EA580C",
  },
  relationshipLabel: {
    fontWeight: 600,
    color: "#111827",
  },
  factsTalkRatioSection: {
    mb: 3,
  },
  factsSubheading: {
    fontSize: "13px",
    fontWeight: 600,
    mb: 1,
  },
  factsRatioLabels: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    mb: 1,
  },
  factsRatioLabelGroup: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  factsRatioDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
  factsRatioDotAccount: {
    backgroundColor: "#9333EA",
  },
  factsRatioDotClient: {
    backgroundColor: "#2563EB",
  },
  factsRatioDotOther: {
    backgroundColor: "#D1D5DB",
  },
  factsRatioText: {
    fontSize: "13px",
  },
  factsRatioSeparator: {
    color: "#9CA3AF",
  },
  factsProgressBar: {
    height: "10px",
    borderRadius: "999px",
    overflow: "hidden",
    display: "flex",
    backgroundColor: "#F3F4F6",
  },
  factsMetricCards: {
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
  },
  factsMetricCard: {
    flex: 1,
    minWidth: "200px",
    p: 1.5,
    borderRadius: "10px",
    border: "1px solid #E5E7EB",
  },
  factsMetricCardDuration: {
    background: "linear-gradient(135deg, #F9FAFB, #EFF6FF)",
  },
  factsMetricCardInteraction: {
    background: "linear-gradient(135deg, #F9FAFB, #F5F3FF)",
  },
  factsMetricLabel: {
    fontSize: "11px",
    color: "#6B7280",
    textTransform: "uppercase",
  },
  factsMetricValue: {
    fontSize: "15px",
    fontWeight: 600,
  },
  factsIconGraphic: {
    fontSize: 16,
    color: "#4F46E5",
  },
  factsContactGroup: {
    mb: 3,
  },
  factsContactLabel: {
    fontSize: "13px",
    fontWeight: 600,
    mb: 1,
  },
  factsContactChips: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  factsContactChip: {
    px: 1.5,
    py: "4px",
    borderRadius: "999px",
    backgroundColor: "#EDEDED",
    color: "#212121",
    fontSize: "12px",
    border: "1px solid #EDEDED",
  },
  topicSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "18px",
  },
  topicSectionIcon: {
    width: 28,
    height: 28,
    borderRadius: "9px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  positiveTopicIcon: {
    backgroundColor: "#DCFCE7",
  },
  concerningTopicIcon: {
    backgroundColor: "#FFE2E2",
  },
  concerningTopicIconGraphic: {
    fontSize: 18,
    color: "#DC2626",
  },
  topicSectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1F1F1F",
    lineHeight: 1.3,
  },
  topicAccordion: {
    borderRadius: "12px !important",
    mb: 1,
    transition: "all 0.2s ease",
    overflow: "hidden",
    "&:before": {
      display: "none",
    },
  },
  topicAccordionPositive: {
    border: "1px solid #E5E7EB",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#ECFDF5",
    },
  },
  topicAccordionPositiveExpanded: {
    border: "1px solid #86EFAC",
    backgroundColor: "#F7FFFB",
  },
  topicAccordionConcerning: {
    border: "1px solid #E5E7EB",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#FEF2F2",
    },
  },
  topicAccordionConcerningExpanded: {
    border: "1px solid #FCA5A5",
    backgroundColor: "#FFF8F8",
  },
  topicAccordionExpandIcon: {
    fontSize: "18px",
    color: "#6B7280",
    transition: "0.2s",
  },
  topicAccordionSummaryModern: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    px: 2,
    py: 1.5,
    minHeight: "unset",
    "& .MuiAccordionSummary-content": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      my: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      my: 0,
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(180deg)",
    },
  },
  topicAccordionIndex: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#6B7280",
    width: "22px",
  },
  topicAccordionTopic: {
    flex: 1,
    fontSize: "14px",
    fontWeight: 500,
    color: "#111827",
  },
  topicAccordionDetailsModern: {
    px: 2,
    pb: 2,
    pt: 1,
    borderTop: "1px solid #E5E7EB",
  },
  topicAccordionList: {
    pl: 3,
    m: 0,
    listStyleType: "disc",
  },
  topicAccordionItem: {
    fontSize: "13px",
  },
  topicAccordionSummaryItem: {
    fontSize: "13px",
    lineHeight: 1.7,
  },
  topicEmptyState: {
    fontSize: "13px",
  },
  concernGroupsStack: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  concernGroupAccordion: {
    borderRadius: "12px !important",
    overflow: "hidden",
    transition: "all 0.3s ease",
    "&:before": {
      display: "none",
    },
  },
  concernGroupPrimary: {
    border: "2px solid #FECACA",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 4px 10px rgba(17, 24, 39, 0.08)",
    "&:hover": {
      boxShadow: "0 10px 18px rgba(17, 24, 39, 0.11)",
    },
  },
  concernGroupPrimaryExpanded: {
    border: "0",
    background: "linear-gradient(135deg, #FEF2F2 0%, #FFF1F2 52%, #FEF2F2 100%)",
    boxShadow: "0 18px 26px rgba(127, 29, 29, 0.14)",
    outline: "2px solid #FCA5A5",
    outlineOffset: "-2px",
  },
  concernGroupOther: {
    border: "2px solid #FDE68A",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 4px 10px rgba(17, 24, 39, 0.08)",
    "&:hover": {
      boxShadow: "0 10px 18px rgba(17, 24, 39, 0.11)",
    },
  },
  concernGroupOtherExpanded: {
    border: "0",
    background: "linear-gradient(135deg, #FFFBEB 0%, #FFF7ED 52%, #FFFBEB 100%)",
    boxShadow: "0 18px 26px rgba(146, 64, 14, 0.14)",
    outline: "2px solid #FCD34D",
    outlineOffset: "-2px",
  },
  concernGroupSummary: {
    px: 2.5,
    py: 1.5,
    minHeight: "unset",
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      my: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      my: 0,
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      display: "none",
    },
  },
  concernGroupCopy: {
    flex: 1,
    minWidth: 0,
  },
  concernGroupTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#111827",
    lineHeight: 1.3,
  },
  concernGroupSubtitle: {
    fontSize: "12px",
    color: "#6B7280",
    mt: "2px",
    lineHeight: 1.35,
  },
  concernGroupActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
  },
  concernGroupBadge: {
    px: "12px",
    py: "5px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: 1,
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  },
  concernGroupPrimaryBadge: {
    backgroundColor: "#FEE2E2",
    color: "#B91C1C",
    border: "1px solid #FCA5A5",
  },
  concernGroupPrimaryBadgeExpanded: {
    backgroundColor: "#FFFFFF",
    color: "#B91C1C",
    border: "1px solid transparent",
    boxShadow: "0 4px 10px rgba(127, 29, 29, 0.12)",
  },
  concernGroupOtherBadge: {
    backgroundColor: "#FEF3C7",
    color: "#B45309",
    border: "1px solid #FCD34D",
  },
  concernGroupOtherBadgeExpanded: {
    backgroundColor: "#FFFFFF",
    color: "#B45309",
    border: "1px solid transparent",
    boxShadow: "0 4px 10px rgba(146, 64, 14, 0.12)",
  },
  concernChevronWrap: {
    width: 32,
    height: 32,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
  },
  concernGroupChevronIcon: {
    fontSize: 20,
  },
  concernGroupPrimaryChevron: {
    backgroundColor: "#FEE2E2",
    color: "#DC2626",
    ".MuiAccordionSummary-root:hover &": {
      backgroundColor: "#FECACA",
    },
  },
  concernGroupPrimaryChevronExpanded: {
    backgroundColor: "rgba(255, 255, 255, 0.55)",
    color: "#B91C1C",
    transform: "rotate(180deg)",
  },
  concernGroupOtherChevron: {
    backgroundColor: "#FEF3C7",
    color: "#D97706",
    ".MuiAccordionSummary-root:hover &": {
      backgroundColor: "#FDE68A",
    },
  },
  concernGroupOtherChevronExpanded: {
    backgroundColor: "rgba(255, 255, 255, 0.55)",
    color: "#B45309",
    transform: "rotate(180deg)",
  },
  concernGroupDetails: {
    px: 2.5,
    pb: 2,
    pt: 0,
  },
  concernSubStack: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    mt: 1.5,
  },
  concernDomainGroupsStack: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    mt: 0.75,
  },
  concernDomainGroup: {
    position: "relative",
    pl: "20px",
    "&:before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "1px",
      background: "linear-gradient(180deg, currentColor 0%, currentColor 58%, transparent 100%)",
      opacity: 0.78,
    },
  },
  concernDomainGroupPrimary: {
    color: "#EF4444",
  },
  concernDomainGroupOther: {
    color: "#D9942F",
  },
  concernDomainTitle: {
    fontSize: "11px",
    fontWeight: 500,
    lineHeight: 1.25,
    letterSpacing: "2.6px",
    textTransform: "uppercase",
    mb: "12px",
  },
  concernDomainTitlePrimary: {
    color: "#EF4444",
  },
  concernDomainTitleOther: {
    color: "#D9942F",
  },
  concernSubAccordion: {
    borderRadius: "12px !important",
    overflow: "hidden",
    transition: "all 0.3s ease",
    "&:before": {
      display: "none",
    },
  },
  concernSubClosed: {
    border: "1px solid #E5E7EB",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 1px 3px rgba(17, 24, 39, 0.08)",
    "&:hover": {
      boxShadow: "0 4px 10px rgba(17, 24, 39, 0.11)",
    },
  },
  concernSubPrimaryExpanded: {
    border: "0",
    background: "linear-gradient(135deg, #FEF2F2 0%, #FFFFFF 52%, #FEF2F2 100%)",
    boxShadow: "0 10px 18px rgba(127, 29, 29, 0.12)",
    outline: "2px solid #FECACA",
    outlineOffset: "-2px",
  },
  concernSubPositiveExpanded: {
    border: "0",
    background: "linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 52%, #ECFDF5 100%)",
    boxShadow: "0 10px 18px rgba(22, 101, 52, 0.12)",
    outline: "2px solid #86EFAC",
    outlineOffset: "-2px",
  },
  concernSubOtherExpanded: {
    border: "0",
    background: "linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 52%, #FFFBEB 100%)",
    boxShadow: "0 10px 18px rgba(146, 64, 14, 0.12)",
    outline: "2px solid #FDE68A",
    outlineOffset: "-2px",
  },
  concernSubSummary: {
    px: 2,
    py: 1.35,
    minHeight: "unset",
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      gap: "12px",
      my: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      my: 0,
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      display: "none",
    },
  },
  concernSubIndex: {
    width: 28,
    height: 28,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 700,
    flexShrink: 0,
    transition: "all 0.3s ease",
  },
  concernSubIndexClosed: {
    backgroundColor: "#F3F4F6",
    color: "#4B5563",
    ".MuiAccordionSummary-root:hover &": {
      backgroundColor: "#E5E7EB",
    },
  },
  concernSubIndexPrimaryExpanded: {
    background: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
    color: "#FFFFFF",
    boxShadow: "0 4px 8px rgba(220, 38, 38, 0.25)",
  },
  concernSubIndexPositiveExpanded: {
    background: "linear-gradient(135deg, #22C55E 0%, #16A34A 100%)",
    color: "#FFFFFF",
    boxShadow: "0 4px 8px rgba(22, 163, 74, 0.25)",
  },
  concernSubIndexOtherExpanded: {
    background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
    color: "#FFFFFF",
    boxShadow: "0 4px 8px rgba(217, 119, 6, 0.25)",
  },
  concernSubTopic: {
    flex: 1,
    minWidth: 0,
    fontSize: "14px",
    fontWeight: 500,
    color: "#374151",
    lineHeight: 1.4,
    transition: "color 0.2s ease",
    ".MuiAccordionSummary-root:hover &": {
      color: "#111827",
    },
  },
  concernSubTopicExpanded: {
    color: "#111827",
  },
  concernSubHeaderContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  concernSubTopicWithTags: {
    flex: "0 1 auto",
    minWidth: 0,
  },
  concernTagsRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "wrap",
    minWidth: 0,
  },
  concernTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    px: "8px",
    py: "2px",
    borderRadius: "8px",
    backgroundColor: "#F8FAFC",
    border: "1px solid #E2E8F0",
    color: "#475569",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1.25,
    whiteSpace: "nowrap",
  },
  concernTagLabel: {
    color: "#8A94A6",
    fontWeight: 600,
  },
  concernTagValue: {
    color: "#334155",
    fontWeight: 700,
  },
  concernSubChevronClosed: {
    backgroundColor: "#F3F4F6",
    color: "#6B7280",
    ".MuiAccordionSummary-root:hover &": {
      backgroundColor: "#E5E7EB",
    },
  },
  concernSubChevronIcon: {
    fontSize: 18,
  },
  concernSubPrimaryChevronExpanded: {
    backgroundColor: "#FEE2E2",
    color: "#DC2626",
    transform: "rotate(180deg)",
  },
  concernSubPositiveChevronExpanded: {
    backgroundColor: "#DCFCE7",
    color: "#16A34A",
    transform: "rotate(180deg)",
  },
  concernSubOtherChevronExpanded: {
    backgroundColor: "#FEF3C7",
    color: "#D97706",
    transform: "rotate(180deg)",
  },
  concernSubDetails: {
    px: 2.5,
    py: 2,
  },
  concernSubPrimaryDetails: {
    borderTop: "1px solid #FEE2E2",
  },
  concernSubPositiveDetails: {
    borderTop: "1px solid #DCFCE7",
  },
  concernSubOtherDetails: {
    borderTop: "1px solid #FEF3C7",
  },
  concernDetailsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    m: 0,
    p: 0,
    listStyle: "none",
  },
  concernDetailsItem: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  concernInlineMetaRow: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "4px 14px",
    minWidth: 0,
  },
  concernInlineMetaText: {
    position: "relative",
    fontSize: "13px",
    color: "#4B5563",
    lineHeight: 1.7,
    maxWidth: "100%",
    pr: "14px",
    "&:not(:last-of-type):after": {
      content: '"|"',
      position: "absolute",
      right: 0,
      top: 0,
      color: "#4B5563",
      fontWeight: 600,
    },
  },
  concernDetailsBullet: {
    width: 6,
    height: 6,
    borderRadius: "999px",
    flexShrink: 0,
    mt: "7px",
  },
  concernDetailsBulletPrimary: {
    backgroundColor: "#F87171",
  },
  concernDetailsBulletPositive: {
    backgroundColor: "#4ADE80",
  },
  concernDetailsBulletOther: {
    backgroundColor: "#FBBF24",
  },
  concernDetailsText: {
    fontSize: "13px",
    color: "#4B5563",
    lineHeight: 1.7,
    flex: 1,
  },
  positiveTopicsHeader: {
    px: 2,
    py: 1.5,
    backgroundColor: "#F7F7F8",
    borderBottom: "1px solid #EAEAEA",
  },
  negativeTopicsHeader: {
    px: 2,
    py: 1.5,
    backgroundColor: "#F7F7F8",
    borderBottom: "1px solid #EAEAEA",
  },
  topicSection: {
    border: "1px solid #EAEAEA",
    borderRadius: "8px",
    overflow: "hidden",
  },
  accordionExpandIcon: {
    width: 12,
    height: 12,
    minWidth: 12,
    minHeight: 12,
    flexShrink: 0,
  },
  topicAccordionSummary: {
    minHeight: "56px",
    px: 2.5,
    "& .MuiAccordionSummary-content": {
      margin: "12px 0",
      alignItems: "center",
    },
  },
  topicAccordionDetails: {
    px: 4,
    pb: 2,
  },
} as const;

export const getTopicAccordionStyles = (
  variant: "positive" | "concerning",
  isExpanded: boolean
) => {
  if (variant === "positive") {
    return [
      fingertipMetricViewStyles.topicAccordion,
      fingertipMetricViewStyles.topicAccordionPositive,
      isExpanded && fingertipMetricViewStyles.topicAccordionPositiveExpanded,
    ];
  }

  return [
    fingertipMetricViewStyles.topicAccordion,
    fingertipMetricViewStyles.topicAccordionConcerning,
    isExpanded && fingertipMetricViewStyles.topicAccordionConcerningExpanded,
  ];
};

export const getConcernGroupAccordionStyles = (
  variant: ConcernGroupVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernGroupAccordion,
  variant === "primary"
    ? fingertipMetricViewStyles.concernGroupPrimary
    : fingertipMetricViewStyles.concernGroupOther,
  isExpanded &&
    (variant === "primary"
      ? fingertipMetricViewStyles.concernGroupPrimaryExpanded
      : fingertipMetricViewStyles.concernGroupOtherExpanded),
];

export const getConcernGroupBadgeStyles = (
  variant: ConcernGroupVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernGroupBadge,
  variant === "primary"
    ? fingertipMetricViewStyles.concernGroupPrimaryBadge
    : fingertipMetricViewStyles.concernGroupOtherBadge,
  isExpanded &&
    (variant === "primary"
      ? fingertipMetricViewStyles.concernGroupPrimaryBadgeExpanded
      : fingertipMetricViewStyles.concernGroupOtherBadgeExpanded),
];

export const getConcernGroupChevronStyles = (
  variant: ConcernGroupVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernChevronWrap,
  variant === "primary"
    ? fingertipMetricViewStyles.concernGroupPrimaryChevron
    : fingertipMetricViewStyles.concernGroupOtherChevron,
  isExpanded &&
    (variant === "primary"
      ? fingertipMetricViewStyles.concernGroupPrimaryChevronExpanded
      : fingertipMetricViewStyles.concernGroupOtherChevronExpanded),
];

export const getConcernDomainGroupStyles = (variant: ConcernGroupVariant) => [
  fingertipMetricViewStyles.concernDomainGroup,
  variant === "primary"
    ? fingertipMetricViewStyles.concernDomainGroupPrimary
    : fingertipMetricViewStyles.concernDomainGroupOther,
];

export const getConcernDomainTitleStyles = (variant: ConcernGroupVariant) => [
  fingertipMetricViewStyles.concernDomainTitle,
  variant === "primary"
    ? fingertipMetricViewStyles.concernDomainTitlePrimary
    : fingertipMetricViewStyles.concernDomainTitleOther,
];

export const getConcernSubAccordionStyles = (
  variant: TopicConcernVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernSubAccordion,
  isExpanded
    ? variant === "positive"
      ? fingertipMetricViewStyles.concernSubPositiveExpanded
      : variant === "primary"
      ? fingertipMetricViewStyles.concernSubPrimaryExpanded
      : fingertipMetricViewStyles.concernSubOtherExpanded
    : fingertipMetricViewStyles.concernSubClosed,
];

export const getConcernSubIndexStyles = (
  variant: TopicConcernVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernSubIndex,
  isExpanded
    ? variant === "positive"
      ? fingertipMetricViewStyles.concernSubIndexPositiveExpanded
      : variant === "primary"
      ? fingertipMetricViewStyles.concernSubIndexPrimaryExpanded
      : fingertipMetricViewStyles.concernSubIndexOtherExpanded
    : fingertipMetricViewStyles.concernSubIndexClosed,
];

export const getConcernSubTopicStyles = (isExpanded: boolean) => [
  fingertipMetricViewStyles.concernSubTopic,
  isExpanded && fingertipMetricViewStyles.concernSubTopicExpanded,
];

export const getConcernSubChevronStyles = (
  variant: TopicConcernVariant,
  isExpanded: boolean
) => [
  fingertipMetricViewStyles.concernChevronWrap,
  isExpanded
    ? variant === "positive"
      ? fingertipMetricViewStyles.concernSubPositiveChevronExpanded
      : variant === "primary"
      ? fingertipMetricViewStyles.concernSubPrimaryChevronExpanded
      : fingertipMetricViewStyles.concernSubOtherChevronExpanded
    : fingertipMetricViewStyles.concernSubChevronClosed,
];

export const getConcernSubDetailsStyles = (variant: TopicConcernVariant) => [
  fingertipMetricViewStyles.concernSubDetails,
  variant === "positive"
    ? fingertipMetricViewStyles.concernSubPositiveDetails
    : variant === "primary"
    ? fingertipMetricViewStyles.concernSubPrimaryDetails
    : fingertipMetricViewStyles.concernSubOtherDetails,
];

export const getConcernDetailsBulletStyles = (variant: TopicConcernVariant) => [
  fingertipMetricViewStyles.concernDetailsBullet,
  variant === "positive"
    ? fingertipMetricViewStyles.concernDetailsBulletPositive
    : variant === "primary"
    ? fingertipMetricViewStyles.concernDetailsBulletPrimary
    : fingertipMetricViewStyles.concernDetailsBulletOther,
];

export const getFactsProgressSegmentStyle = (width: number, backgroundColor: string) => ({
  width: `${width}%`,
  backgroundColor,
});

export const getTrajectoryStyles = (flag?: string) => {
  switch (flag) {
    case "Positive":
      return {
        color: "#116F3B",
        backgroundColor: "#E9FAF0",
         border: "1px solid #e5fdef",
      };
    case "Negative":
      return {
        color: "#B53737",
        backgroundColor: "#FFEDED",
         border: "1px solid #fedbdb",
      };
    case "Neutral":
      return {
        color: "#AE751A",
        backgroundColor: "#FEF6E9",
         border: "1px solid #f4e4c9",
      };
    default:
      return {
        color: "#129455",
        backgroundColor: "#E9F8EF",
         border: "1px solid #116F3B",
      };
  }
};
